import team from "../illustrations/team.svg";
import doctor from "../illustrations/doctor.svg";
import membership from "../illustrations/membership.svg";
import rewards from "../illustrations/rewards.svg";
import records from "../illustrations/records.svg";
import report from "../illustrations/report.svg";
import labwork from "../illustrations/labwork.svg";
import lab from "../illustrations/lab.svg";
import heart from "../illustrations/heart.svg";
import kidney from "../illustrations/kidney.svg";
import consult from "../illustrations/consult.svg";

// Storyset scenes copied from the landing repo's src/illustrations, where
// scripts/import-storyset.py recolours them. The licence needs the credit shown
// in the sidebar footer.
const scenes = { team, doctor, membership, rewards, records, report, labwork, lab, heart, kidney, consult };

export default function Illustration({ name, className = "" }) {
  return <img src={scenes[name]} alt="" aria-hidden="true" loading="lazy" className={`illustration ${className}`.trim()} />;
}

/** A page title with a scene beside it; the scene drops away on narrow screens. */
export function PageHero({ title, subtitle, scene, children }) {
  return (
    <section className="page-hero">
      <div>
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
        {children}
      </div>
      <Illustration name={scene} />
    </section>
  );
}
